var map = {
	"./sso_logo_service_code_bery.png": 84913,
	"./sso_logo_service_code_qou.png": 26901,
	"./sso_logo_service_code_riza.png": 36992,
	"./sso_logo_service_code_uns.png": 77135,
	"./sso_logo_service_code_uos.png": 3271,
	"./sso_logo_service_code_usf.png": 24053
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10228;